import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  output,
  inject,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthSevices } from '@fitness-force/api';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
// import { FactoryHttpLoader } from '../../helpsupport/helpsupport.component';

import { PaymentStatusTimelineComponent } from '@fitness-force/billing';
import { PaymentSummaryComponent } from '../payment-summary/payment-summary.component';
import type { InvoiceClient } from '@fitness-force/models';

@Component({
  selector: 'payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    PaymentStatusTimelineComponent,
    PaymentSummaryComponent,
    TranslateModule,
  ],
})
export class PaymentComponent implements OnInit {
  private authService = inject(AuthSevices);

  readonly showPayment = input(false);
  readonly getInvoiceById$ = input<Observable<InvoiceClient>>(undefined, {
    alias: 'invoiceDetailById',
  });

  readonly closeSidePopupMember = output<{
    hideSidebar: boolean;
    uuid: string | null;
  }>();
  readonly GoToClientSubscription = output<boolean>();

  readonly hidePaymentSidebar = output<boolean>();

  showPaymentStatusTimeLine = false;

  uuid: string;
  ispayment = false;
  currentUserDetails: any;

  ngOnInit(): void {
    this.currentUserDetails = this.authService.decodedToken;
  }

  ClosePaymentSummary(evt: any) {
    if (evt.clientSignupUUID) {
      this.ispayment = true;
      this.hidePaymentSidebar.emit(true);
      this.uuid = evt.clientSignupUUID;
      this.showPaymentStatusTimeLine = true;
    } else {
      this.hidePaymentSidebar.emit(true);
      this.GoToClientDetails();
    }
  }

  GoToClientDetails() {
    this.hidePaymentSidebar.emit(true);
    this.showPaymentStatusTimeLine = false;
    this.hidePaymentSidebar.emit(false);
  }
}
